import { PRODUCT_NAMES } from '@instanexus/contracts';
import { useTermsLinks } from '@instanexus/i18n';
import { AuthLayout } from '@instanexus/ui';
import type { ReactElement, ReactNode } from 'react';

/** `AuthLayout` with the InstaCheckin brand and terms links filled in. */
export function AuthCardLayout({ children }: { children: ReactNode }): ReactElement {
  const termsLinks = useTermsLinks();
  return (
    <AuthLayout termsLinks={termsLinks} brandName={PRODUCT_NAMES.platform}>
      {children}
    </AuthLayout>
  );
}
